/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
EXTENDED SETTINGS
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
:host([error]) {
  background-color: #ff74a2;
}

:host([alert]) {
  background-color: #ffc270;
}

:host([success]) {
  background-color: #85d0c1;
}

:host([info]) {
  background-color: #8494ff;
}

:host([dark]) {
  background-color: #0a171f;
  color: #fff;
}

:host([accent]) {
  background-color: #eaf7ff;
}

:host([info]) {
  display: inline-block;
  margin-right: 2em;
}

/* top, bottom and y paddings */
:host([p-0]), :host([pt-0]), :host([py-0]) {
  padding-top: 0;
}

:host([p-0]), :host([pb-0]), :host([py-0]) {
  padding-bottom: 0;
}

:host([p-1]), :host([pt-1]), :host([py-1]), ::slotted([p-1]), ::slotted([pt-1]), ::slotted([py-1]) {
  padding-top: 12px;
}

:host([p-1]), :host([pb-1]), :host([py-1]), ::slotted([p-1]), ::slotted([pb-1]), ::slotted([py-1]) {
  padding-bottom: 12px;
}

:host([p-2]), :host([pt-2]), :host([py-2]), ::slotted([p-2]), ::slotted([pt-2]), ::slotted([py-2]) {
  padding-top: 24px;
}

:host([p-2]), :host([pb-2]), :host([py-2]), ::slotted([p-2]), ::slotted([pb-2]), ::slotted([py-2]) {
  padding-bottom: 24px;
}

:host([p-3]), :host([pt-3]), :host([py-3]), ::slotted([p-3]), ::slotted([pt-3]), ::slotted([py-3]) {
  padding-top: 32px;
}

:host([p-3]), :host([pb-3]), :host([py-3]), ::slotted([p-3]), ::slotted([pb-3]), ::slotted([py-3]) {
  padding-bottom: 32px;
}

:host([p-4]), :host([pt-4]), :host([py-4]), ::slotted([p-4]), ::slotted([pt-4]), ::slotted([py-3]) {
  padding-top: 40px;
}

:host([p-4]), :host([pb-4]), :host([py-4]), ::slotted([p-4]), ::slotted([pb-4]), ::slotted([py-4]) {
  padding-bottom: 40px;
}

:host([p-5]), :host([pt-5]), :host([py-5]) {
  padding-top: 80px;
}

:host([p-5]), :host([pb-5]), :host([py-5]) {
  padding-bottom: 80px;
}

/* left, right and x paddings */
:host([p-0]), :host([pl-0]), :host([px-0]) {
  padding-left: 0;
}

:host([p-0]), :host([pr-0]), :host([px-0]) {
  padding-right: 0;
}

:host([p-1]), :host([pl-1]), :host([px-1]) {
  padding-left: 12px;
}

:host([p-1]), :host([pr-1]), :host([px-1]) {
  padding-right: 12px;
}

:host([p-2]), :host([pl-2]), :host([px-2]) {
  padding-left: 24px;
}

:host([p-2]), :host([pr-2]), :host([px-2]) {
  padding-right: 24px;
}

:host([p-3]), :host([pl-3]), :host([px-3]) {
  padding-left: 32px;
}

:host([p-3]), :host([pr-3]), :host([px-2]) {
  padding-right: 32px;
}

:host([p-4]), :host([pl-4]), :host([px-4]) {
  padding-left: 40px;
}

:host([p-4]), :host([pr-4]), :host([px-4]) {
  padding-right: 40px;
}

:host([p-5]), :host([pl-5]), :host([px-5]) {
  padding-left: 80px;
}

:host([p-5]), :host([pr-5]), :host([px-5]) {
  padding-right: 80px;
}

/* ToDo: Own Mixin for layout */
:host([layout-stretch]), ::slotted([layout-stretch]) {
  display: flex;
  flex-direction: row;
  align-content: space-between;
}

/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
Reset Button
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ---------------------------------------------------
A11y-focus
--------------------------------------------------- */
/* ===================================================
Reset Button
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
Pseudo Element
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
Button and Link Styles
=================================================== */
/* ===================================================
Hiding Elements
=================================================== */
/* ---------------------------------------------------
ir
--------------------------------------------------- */
/* ---------------------------------------------------
Hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Visually hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Visibility hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Hide text
--------------------------------------------------- */
/* ===================================================
Pseudo Element
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
CENTERING MIXIN
=================================================== */
:host {
  display: block;
  margin-bottom: 0;
  font-size: 1.4rem;
  line-height: calc(1.4rem + .4rem);
  font-family: "Fira Sans";
  /*
  Headlines
  ----------------------------- */
  /*
  Paragraph
  ----------------------------- */
  /*
  Lists
  ----------------------------- */
  /*
  Others
  ----------------------------- */
}
:host ::slotted(*) {
  display: none;
}
@media only screen and (min-width: 414px) {
  :host {
    font-size: calc(1.4rem + calc(.1rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.1rem * 1));
  }
}
@media only screen and (min-width: 768px) {
  :host {
    font-size: calc(1.4rem + calc(.2rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.2rem * 1));
  }
}
@media only screen and (min-width: 960px) {
  :host {
    font-size: calc(1.4rem + calc(.3rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.3rem * 1));
  }
}
@media only screen and (min-width: 1120px) {
  :host {
    font-size: calc(1.4rem + calc(.4rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.4rem * 1));
  }
}
:host h1 {
  font-family: "PT Sans Narrow", "Arial Narrow", Helvetica, Arial, sans-serif;
  font-size: var(--fontsize-header-h1-xs, 2.2rem);
  line-height: calc(var(--fontsize-header-h1-xs, 2.2rem) + .4rem);
}
@media only screen and (min-width: 414px) {
  :host h1 {
    font-size: calc(var(--fontsize-header-h1-xs, 2.2rem) + calc(.1rem * 2));
    line-height: calc(calc(var(--fontsize-header-h1-xs, 2.2rem) + .4rem) + calc(.1rem * 2));
  }
}
@media only screen and (min-width: 768px) {
  :host h1 {
    font-size: calc(var(--fontsize-header-h1-xs, 2.2rem) + calc(.2rem * 2));
    line-height: calc(calc(var(--fontsize-header-h1-xs, 2.2rem) + .4rem) + calc(.2rem * 2));
  }
}
@media only screen and (min-width: 960px) {
  :host h1 {
    font-size: calc(var(--fontsize-header-h1-xs, 2.2rem) + calc(.3rem * 2));
    line-height: calc(calc(var(--fontsize-header-h1-xs, 2.2rem) + .4rem) + calc(.3rem * 2));
  }
}
@media only screen and (min-width: 1120px) {
  :host h1 {
    font-size: calc(var(--fontsize-header-h1-xs, 2.2rem) + calc(.4rem * 2));
    line-height: calc(calc(var(--fontsize-header-h1-xs, 2.2rem) + .4rem) + calc(.4rem * 2));
  }
}
:host h2 {
  font-size: 1.8rem;
  line-height: calc(1.8rem + .4rem);
  color: #183447;
  margin-top: 16px;
  margin-bottom: 16px;
}
@media only screen and (min-width: 414px) {
  :host h2 {
    font-size: calc(1.8rem + calc(.1rem * 1));
    line-height: calc(calc(1.8rem + .4rem) + calc(.1rem * 1));
  }
}
@media only screen and (min-width: 768px) {
  :host h2 {
    font-size: calc(1.8rem + calc(.2rem * 1));
    line-height: calc(calc(1.8rem + .4rem) + calc(.2rem * 1));
  }
}
@media only screen and (min-width: 960px) {
  :host h2 {
    font-size: calc(1.8rem + calc(.3rem * 1));
    line-height: calc(calc(1.8rem + .4rem) + calc(.3rem * 1));
  }
}
@media only screen and (min-width: 1120px) {
  :host h2 {
    font-size: calc(1.8rem + calc(.4rem * 1));
    line-height: calc(calc(1.8rem + .4rem) + calc(.4rem * 1));
  }
}
:host h2:first-child {
  margin-top: 0;
}
:host h3,
:host h4,
:host h5,
:host h6 {
  font-size: 1.4rem;
  line-height: calc(1.4rem + .4rem);
}
@media only screen and (min-width: 414px) {
  :host h3,
:host h4,
:host h5,
:host h6 {
    font-size: calc(1.4rem + calc(.1rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.1rem * 1));
  }
}
@media only screen and (min-width: 768px) {
  :host h3,
:host h4,
:host h5,
:host h6 {
    font-size: calc(1.4rem + calc(.2rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.2rem * 1));
  }
}
@media only screen and (min-width: 960px) {
  :host h3,
:host h4,
:host h5,
:host h6 {
    font-size: calc(1.4rem + calc(.3rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.3rem * 1));
  }
}
@media only screen and (min-width: 1120px) {
  :host h3,
:host h4,
:host h5,
:host h6 {
    font-size: calc(1.4rem + calc(.4rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.4rem * 1));
  }
}
:host p {
  font-size: 1.4rem;
  line-height: calc(1.4rem + .4rem);
  margin-bottom: 24px;
}
@media only screen and (min-width: 414px) {
  :host p {
    font-size: calc(1.4rem + calc(.1rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.1rem * 1));
  }
}
@media only screen and (min-width: 768px) {
  :host p {
    font-size: calc(1.4rem + calc(.2rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.2rem * 1));
  }
}
@media only screen and (min-width: 960px) {
  :host p {
    font-size: calc(1.4rem + calc(.3rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.3rem * 1));
  }
}
@media only screen and (min-width: 1120px) {
  :host p {
    font-size: calc(1.4rem + calc(.4rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.4rem * 1));
  }
}
:host p:last-child {
  margin-bottom: 0;
}
:host p:first-child {
  margin-top: 0;
}
:host strong,
:host b {
  font-weight: 700;
}
:host em,
:host i {
  font-style: italic;
}
:host ul {
  list-style: square;
  padding-inline-start: 18px;
  margin-bottom: 24px;
  font-size: 1.4rem;
  line-height: calc(1.4rem + .4rem);
}
@media only screen and (min-width: 414px) {
  :host ul {
    font-size: calc(1.4rem + calc(.1rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.1rem * 1));
  }
}
@media only screen and (min-width: 768px) {
  :host ul {
    font-size: calc(1.4rem + calc(.2rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.2rem * 1));
  }
}
@media only screen and (min-width: 960px) {
  :host ul {
    font-size: calc(1.4rem + calc(.3rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.3rem * 1));
  }
}
@media only screen and (min-width: 1120px) {
  :host ul {
    font-size: calc(1.4rem + calc(.4rem * 1));
    line-height: calc(calc(1.4rem + .4rem) + calc(.4rem * 1));
  }
}
:host ul:last-child {
  margin-bottom: 0;
}
:host ul li::marker {
  color: #8393A3;
}
:host li {
  position: relative;
  margin: 0 0 8px 0;
  padding-left: 4px;
}
:host li:last-child {
  margin-bottom: 0;
}
:host ol li {
  list-style: decimal;
}
:host a:not([class]) {
  position: relative;
  display: inline-block;
  color: inherit;
}
:host a:not([class]):hover::after, :host a:not([class]):focus::after {
  width: 0;
}
:host a:not([class])::after {
  width: 100%;
  height: 1px;
  bottom: 0;
  background-color: #0a171f;
  transition: width 300ms ease-in-out;
}
:host a:not([class])[href^=mailto] {
  font-weight: 700;
}
:host a:not([class])[href^=mailto]::after {
  height: 2px;
}
:host sup {
  font-size: 0.83em;
  vertical-align: super;
}
:host sub {
  font-size: 0.83em;
  vertical-align: sub;
}
:host hr {
  margin-top: 0;
  margin-bottom: 24px;
  height: 1px;
  background-color: rgba(10, 23, 31, 0.24);
  border: none;
}